// the clean way of getting an elements width
export const useWidth = (element) => +getComputedStyle(element).width.slice(0, -2);
